import React, { useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Devices/NewDevice.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
const NewDevice = ({showNewDeviceWindow,setShowNewDeviceWindow,accessToken,serverUrl}) =>{
    const [customers,setCustomers] = useState(null);
    const [formValues,setFormValues] = useState({
        name:'',
        label:'',
        customerId:'',
        description:''
    });
    const handleFormValueChange = (e) =>{
        const {name,value} = e.target;
        setFormValues(prevValues => ({...prevValues,[name]:value}));
    };
    const clearAllEntries = () =>{
        setFormValues({
            name:'',
            label:'',
            customerId:'',
            description:''
        });
    };
    const createDevice = async() =>{
        try{
            const newDeviceData = {
                name:formValues.name,
                label:formValues.label,
                customerId:formValues.customerId,
                description:formValues.description,
                serverUrl:serverUrl
            };
            const url = `${thingsBoardMicroserviceUrl}/tenants/devices/create`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(newDeviceData)
            });
        }
        catch(error){
            console.error(error);
        }
    };
    const fetchAllCustomers = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/customers/all/get?url=${serverUrl}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCustomers(responseData);
            }
            else throw new Error(`Network response was not ok ${response.status}`);
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() => {
        const refreshCustomers = async() =>{
            if(showNewDeviceWindow) await fetchAllCustomers();
        };
        refreshCustomers();
    },[showNewDeviceWindow]);
    if(!showNewDeviceWindow) return null;
    return(
        <div className="new-device-container">
            <div className="new-device-header">
                <h3>Add new device</h3>
            </div>
            <div className="new-device-body">
                <input
                    name="name"
                    placeholder="Name"
                    value={formValues.name}
                    onChange={handleFormValueChange}
                />
                <input
                    name="label"
                    placeholder="Label"
                    value={formValues.label}
                    onChange={handleFormValueChange}
                />
                <select
                    name="customerId"
                    value={formValues.customerId}
                    onChange={handleFormValueChange}
                >
                    <option value="" disabled>Customer</option>
                    {customers && customers.map((customer) => (
                        <option key={customer.id.id} value={customer.id.id}>
                            {customer.name}
                        </option>
                    ))}
                </select>
                <input
                    name="description"
                    placeholder="Description"
                    value={formValues.description}
                    onChange={handleFormValueChange}
                />
            </div>
            <div className="new-device-container-buttons">
                <button onClick={() => {
                    clearAllEntries();
                    setShowNewDeviceWindow(false);
                }}>Cancel</button>
                <button onClick={async() => {
                    clearAllEntries();
                    setShowNewDeviceWindow(false);
                    await createDevice();
                }}>Add</button>
            </div>
        </div>
    );
};
export default NewDevice;